<template>
	<v-dialog
		:fullscreen="true"
		:model-value="hasNetworkConnectionError"
		transition="fade-transition"
	>
		<v-sheet class="d-flex align-center">
			<v-container class="px-12">
				<v-row
					align="center"
					justify="center"
					class="text-center"
				>
					<v-col cols="12" class="py-12">
						<v-icon icon="mdi-wifi-remove" size="250" color="red" />
					</v-col>
					<v-col cols="12" class="py-12">
						<h1 class="pt-12 pb-6">
							{{ t('Oops, No Internet Connection') }}
						</h1>
						<div style="font-size: 2rem;" class="pb-12">
							{{ t('We are having some connectivity issues, please try the next KIOSK or ask the next cashier for assistance') }}
						</div>
					</v-col>
					<v-col cols="12" class="py-12">
						<v-btn
							color="red"
							variant="flat"
							height="100"
							width="300"
							style="border-radius: 10px!important;"
							@click="retryNetworkConnection"
							@touchend="retryNetworkConnection"
						>
							<div style="font-size: 2rem;">
								{{ t('Try again') }}
							</div>
						</v-btn>
					</v-col>
				</v-row>
			</v-container>
		</v-sheet>
	</v-dialog>
</template>

<script>
import { useStore } from '../stores/store'
import { useI18n } from 'vue-i18n'

export default {
	name: "NetworkConnectionErrorScreen",
	setup() {
		const store = useStore()
		const { t, te } = useI18n()

		return {
			store,
			te,
			t
		}
	},
	data() {
		return {
			tryingNetworkConnection: false
		}
	},
	computed: {
		hasNetworkConnectionError() {
			return this.store.hasNetworkConnectionError
		}
	},
	methods: {
		retryNetworkConnection() {
			if(this.tryingNetworkConnection) {
				return
			}
			this.tryingNetworkConnection = true
			setTimeout(() => {
				this.store.gettingInitialData = true
				this.store.showInitialSetupScreen = true
				this.store.hasNetworkConnectionError = false
				this.store.getKioskData()
				this.tryingNetworkConnection = false
			}, 200)
		}
	}
}
</script>

<style scoped>
.error-background {
	background: linear-gradient(0deg, #FFFFFF 57%, red 50%);
}
</style>